import React, { useEffect, useState } from 'react';
import { style } from 'typestyle';
import CheckIcon from 'mdi-react/CheckCircleIcon';
import { useTranslation } from 'react-i18next';
import * as styles from '../cards.styles';
import Column from '../../../../core/components/column/column.component';
import { MainAxisAlignment, CrossAxisAlignment } from '../../../../core/components/flex/flex.component';
import Row from '../../../../core/components/row/row.component';
import type RoomObsolete from '../../../offices/models/room/room-obsolete';
import { type DayPart } from '../../models/daypart-entry';

interface Props {
  readonly room: RoomObsolete;
  readonly isSelected: boolean;
  readonly dayPart: DayPart;
  readonly onClick: (room: RoomObsolete) => void;
}

const DayPartRoomCard = ({ room, isSelected, dayPart, onClick }: Props): React.JSX.Element => {
  const [roomOccupation, setRoomOccupation] = useState(room.roomOccupations?.find((occupation) => occupation.dayPart === dayPart));

  const { t } = useTranslation();

  useEffect(() => {
    setRoomOccupation(room.roomOccupations?.find((occupation) => occupation.dayPart === dayPart));
  }, [room, dayPart]);

  return (
    <div
      className={style(styles.infoCard(true))}
      key={room.name}
      onClick={(): void => {
        onClick(room);
      }}
      role="presentation"
    >
      <Row mainAxisAlignment={MainAxisAlignment.SpaceBetween} crossAxisAlignment={CrossAxisAlignment.Center}>
        <Column mainAxisAlignment={MainAxisAlignment.SpaceBetween}>
          <span className={style(styles.cardHeader())}>{room.name}</span>
        </Column>
        <CheckIcon className={style(styles.checkIcon(isSelected))} />
      </Row>
      {roomOccupation != null && (
        <span className={style(styles.cardBody(true))}>
          {roomOccupation.freeSpaces === 1
            ? t('one-place-available')
            : t('places-available').replace('[x]', roomOccupation.freeSpaces?.toString() ?? '0')}
        </span>
      )}
    </div>
  );
};

export default DayPartRoomCard;
